import { WorkflowContext } from '@samelogic/steps';
import { TriggerEventProps } from '../../../../models';
import { ElementEventProps, ElementEventStrategy } from './ElementEventStrategy';
import { PageEventProps, PageEventStrategy } from './PageEventStrategy';

export type Strategies = ElementEventStrategy | PageEventStrategy;
export class EventStrategyResolver {
  public resolveStrategyByEventType(context: WorkflowContext, props: TriggerEventProps): Strategies {
    switch (props.event) {
      case 'ElementClick':
      case 'ElementMouseOver':
        return new ElementEventStrategy(context, props as ElementEventProps);
      case 'PageView':
        return new PageEventStrategy(context, props as PageEventProps);
      default:
        throw Error(`Unknown eventType`);
    }
  }
}
